import React, { useState } from 'react'
import AllStatesSearchView from './AllStatesSearchView'
import RecordDetailDrawer from '../../Applicants/partial/Tabs/SecretaryOfState/RecordDetailDrawer';
import {saveSosRecord} from 'actions/applicants'
import { Toast } from 'components/shared/Toaster'

const AllStatesSearch = ({ applicantId = '', updateSummaryCard, closeDrawer, creditCosts }) => {

    const [result, setResult] = useState({}) // search result
    const [searchGuid, setSearchGuid] = useState('') // search guid
    const [isRecordDrawerVisible, setIsRecordDrawerVisible] = useState(false) // record drawer visibility

    const handleViewResult = (data, searchGuid) => {
        setResult(data)
        setSearchGuid(searchGuid)
        setIsRecordDrawerVisible(true)
    }

    const handleSaveRecord = (setActionLoading) => {
        const sosId = result.sosId ?? result.taxPayerNumber // use taxPayerNumber as sosId for states like TX that don't provide sosId in search result
        const payload = {
            searchGuid: searchGuid,  // Use searchGuid instead of result.sosSearchId
            sosId: sosId
        }
        saveSosRecord({ applicationId: applicantId, payload })()
            .then(res => {
                Toast({ type: "success", message: res?.message })
                updateSummaryCard()
                // Trigger saved records refresh
                window.dispatchEvent(new Event('refreshSavedRecords'))
                // Close the record detail drawer, but keep the main drawer open
                setIsRecordDrawerVisible(false)
            })
            .catch(() => {
                setActionLoading && setActionLoading(false)
            })
    }

    return (
        <div className="m-3">
            <AllStatesSearchView viewResult={handleViewResult} applicantId={applicantId} creditCosts={creditCosts}/>
            {/* Drawer to show record details */}
            <RecordDetailDrawer
                openDrawer={isRecordDrawerVisible}
                setOpenDrawer={setIsRecordDrawerVisible}
                recordInfo={result}
                isQuickSearch={false}
                handleSaveRecord={handleSaveRecord}
            />
        </div>
    )
}

export default AllStatesSearch